import useQueryParameters from 'hooks/useQueryParameters';
import { pipe, pick, filter } from 'ramda';
import { useMemo } from 'react';

export const useMockAccountData = () => {
  const qp = useQueryParameters();
  const filteredAccountData = useMemo(() => {
    return pipe(
      pick([
        'mockAccountCardType',
        'mockAccountLogo',
        'mockAccountDivisionNumber',
      ]),
      filter(value => value !== undefined),
    )(qp);
  }, [qp]);

  return filteredAccountData;
};
